import store from '@/store'

const routes = [{
    path: '/operations/container-discrepancy/:id',
    name: 'warehousecontainerdiscrepancy',
    component: () => import('@/views/main/modules/Operations/ContainerDiscrepancy/ContainerDiscrepancyGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'ContainerDiscrepancy',
    },
}]

export default routes;
